import React, { Component } from 'react';
import './CriteriaTable.css';
import CriteriaTableBasic from './CriteriaTableBasic';
import CriteriaTableAdvanced from './CriteriaTableAdvanced';

export default class CriteriaTable extends Component {
    // constructor(props) {
        // super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.handleSelectAllSector = this.handleSelectAllSector.bind(this);
        // this.handleScoreBoxChange = this.handleScoreBoxChange.bind(this);
    // }
    handleSelectionBoxChange = (name, value, ischecked) => {
        this.props.handleSelectionBoxChange(name, value, ischecked);
    }
    handleCriteriaBoxChange = (name, value, criteriavalues, cb) => {
        this.props.handleCriteriaBoxChange(name, value, criteriavalues, cb);
    }
    handleSelectAllMarket = () => {
        this.props.handleSelectAllMarket();
    }
    handleSelectAllSector = () => {
        this.props.handleSelectAllSector();
    }
    handleScoreBoxChange = (index, disabled, value) => {
        this.props.handleScoreBoxChange(index, disabled, value);
    }
    handleInvestAmtChange = (investamt) => {
        this.props.handleInvestAmtChange(investamt);
    }
    isSelectAllMarketChecked = () => {
        return this.props.isSelectAllMarketChecked();
    }
    isSelectAllSectorChecked = () => {
        return this.props.isSelectAllSectorChecked();
    }
    render() {
        return (
            <div>
            { this.props.section === "basic"  &&
                <CriteriaTableBasic token={this.props.token} handleSelectionBoxChange={this.handleSelectionBoxChange} handleSelectAllMarket={this.handleSelectAllMarket} isSelectAllMarketChecked={this.isSelectAllMarketChecked} handleSelectAllSector={this.handleSelectAllSector} isSelectAllSectorChecked={this.isSelectAllSectorChecked} handleScoreBoxChange={this.handleScoreBoxChange} handleInvestAmtChange={this.handleInvestAmtChange} criteria={this.props.criteria} data={this.props.data} />
            }
            { this.props.section !== "basic" && 
                <CriteriaTableAdvanced token={this.props.token} fromPreset={this.props.fromPreset} section={this.props.section} handleCriteriaBoxChange={this.handleCriteriaBoxChange} criteria={this.props.criteria} />
            }
            </div>
        );
    }
}